import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makePageTitle } from '@modules/page-title';
import Head from 'next/head';
import type { FC } from 'react';

import styles from './OnboardingMobileLayout.module.scss';

interface OnboardingMobileLayoutProps {
  title: string;
  isOverflowable?: boolean;
}

const OnboardingMobileLayout: FC<React.PropsWithChildren<OnboardingMobileLayoutProps>> = ({
  title,
  children,
  isOverflowable = false,
}) => {
  const pageTitle = makePageTitle(title);
  return (
    <div className={styles['onboarding-layout']} data-is-overflowable={isOverflowable}>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      {children}
    </div>
  );
};

type OnboardingMobileProgressBarProps = {
  totalSteps: number;
  currentStep: number;
};

const OnboardingMobileProgressBar: FC<React.PropsWithChildren<OnboardingMobileProgressBarProps>> = ({
  totalSteps,
  currentStep,
}) => {
  return (
    <div className={styles['onboarding-progress-bar']}>
      <span
        className={styles['onboarding-progress-step']}
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        data-is-last-step={currentStep === totalSteps}
      />
    </div>
  );
};

const OnboardingMobileBackButtonSection: FC<
  React.PropsWithChildren<{
    onBackClick: () => void;
  }>
> = ({ onBackClick }) => {
  return (
    <div className={styles['onboarding-button-section']}>
      <div className={styles['onboarding-button-container']}>
        <button onClick={onBackClick}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span>Back</span>
        </button>
      </div>
    </div>
  );
};

export { OnboardingMobileLayout, OnboardingMobileProgressBar, OnboardingMobileBackButtonSection };
